import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Lightbox from './components/ui/Lightbox';
import Home from './pages/Home';
import Scene from './pages/Scene';
import Rencontres from './pages/Rencontres';
import Etsi from './pages/Etsi';
import Art from './pages/Art';
import Michael from './pages/Michael';
import ArtGraphique from './pages/ArtGraphique';
import Entourage from './pages/Entourage';
import EnfantsPage from './pages/EnfantsPage';
import ActusMembres from './pages/ActusMembres';
import LegendeContinue from './pages/LegendeContinue';
import ProfilPublic from './pages/ProfilPublic';
import Documentaire from './pages/Documentaire';
import AdminVideos from './pages/AdminVideos';
import LiveCams from './pages/LiveCams';
import LiveRoom from './pages/LiveRoom';
import Temoigner from './pages/Temoigner';
import Admin from './pages/Admin';
import Inscription from './pages/Inscription';
import Connexion from './pages/Connexion';
import Profil from './pages/Profil';
import RencontresFans from './pages/RencontresFans';
import CompteConfirme from './pages/CompteConfirme';
import Confidentialite from './pages/Confidentialite';
import MentionsLegales from './pages/MentionsLegales';
import Cgu from './pages/Cgu';
import Merci from './pages/Merci';
import IncomingCallNotif from './components/ui/IncomingCallNotif';
import IncomingMessageNotif from './components/ui/IncomingMessageNotif';
import './styles/globals.css';

export default function App() {
  return (
    <AuthProvider>
      <SocketProvider>
      <BrowserRouter>
        <IncomingCallNotif />
        <IncomingMessageNotif />
        <Navbar />
        <Lightbox />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/scene" element={<Scene />} />
          <Route path="/rencontres" element={<Rencontres />} />
          <Route path="/etsi" element={<Etsi />} />
          <Route path="/art" element={<Art />} />
          <Route path="/michael" element={<Michael />} />
          <Route path="/michael/art-graphique" element={<ArtGraphique />} />
          <Route path="/michael/entourage" element={<Entourage />} />
          <Route path="/michael/enfants" element={<EnfantsPage />} />
          <Route path="/actus" element={<ActusMembres />} />
          <Route path="/legende" element={<LegendeContinue />} />
          <Route path="/membre/:username" element={<ProfilPublic />} />
          <Route path="/documentaire" element={<Documentaire />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/videos" element={<AdminVideos />} />
          <Route path="/live" element={<LiveCams />} />
          <Route path="/live/:roomId" element={<LiveRoom />} />
          <Route path="/temoigner" element={<Temoigner />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/rencontres-fans" element={<RencontresFans />} />
          <Route path="/compte-confirme" element={<CompteConfirme />} />
          <Route path="/confirmer/:token" element={<CompteConfirme />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgu" element={<Cgu />} />
          <Route path="/merci" element={<Merci />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
  );
}
